import Component from '@glimmer/component'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import type { TAB_TYPE_KEYS } from 'teacher-ui-client/components/tab-group/tab-types'
import { getTabTypeClasses, getTabThemeClasses } from 'teacher-ui-client/components/tab-group/tab-types'

interface Args {
  theme?: ThemeKeys
  tabType?: TAB_TYPE_KEYS
  isActive?: boolean
}

interface Signature {
  Args: Args
  Element: HTMLAnchorElement
  Blocks: {
    default: unknown
  }
}

export class TabComponent extends Component<Signature> {
  get tabTypeClasses() {
    return this.args.tabType ? getTabTypeClasses(this.args.tabType) : ''
  }

  get tabThemeClasses() {
    return this.args.tabType && this.args.theme ? getTabThemeClasses(this.args.tabType, this.args.theme) : ''
  }

  <template>
    {{! href="#" indicates a same-page link, and will scroll to the top of the page. href="##" prevents that scroll }}
    <a
      data-test-tab-group-tab={{@theme}}
      href="##"
      class="{{this.tabTypeClasses}} {{this.tabThemeClasses}} {{if @isActive 'active'}}"
      ...attributes
    >
      {{yield}}
    </a>
  </template>
}

export default TabComponent
